import { SecondhandTaxesLandingPageSection } from '../../constants'

export const getListingSectionContent = () => ({
  componentId: SecondhandTaxesLandingPageSection.Listing,
  testId: 'no-changes-to-taxes--listing-section',
  text: {
    title: 'secondhand_taxes.listing.title',
    cta: 'secondhand_taxes.listing.cta',
  },
})
